// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"ac702100","98":"b9f7eb82","105":"81b78742","117":"82ab3e96","243":"f37209bb","334":"a2a6e189","441":"1bb8bbf3","460":"bf7b6d98","601":"f0df1382","632":"553cbce7","708":"e359f763","808":"4e3d9db6","967":"1b919742"}[chunkId] + ".chunk.js";
};